(() => {
  const initialize = () => {
    document.querySelectorAll('[data-product-detail-controls]').forEach((controls) => {
      if (controls.dataset.ready) return;
      controls.dataset.ready = 'true';
      controls.hidden = false;
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-product-details-action]');
        if (!button) return;
        const main = controls.closest('main');
        if (!main) return;
        const expand = button.dataset.productDetailsAction === 'expand';
        main.querySelectorAll('.gfp-topic, .gfp-topic details, .gfp-overview').forEach((details) => {
          details.open = expand;
        });
        controls.querySelector('[data-product-details-status]').textContent = expand
          ? 'All product details and FAQs are expanded.'
          : 'Product details and FAQs are collapsed. Select any heading to read more.';
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
